import authReducer from '../containers/Auth/Login/reducer';
import currentScreen from '../containers/Pages/CreateCourse/Slices/currentScreen';
import currentCourse from '../containers/Pages/CreateCourse/Slices/currentCourse';
import toggleTheme from '../theme/reducer';
import users from '../containers/Pages/Users/Slices/usersSlice';

const rootReducer = {
    auth: authReducer,
    currentScreen,
    currentCourse,
    theme: toggleTheme,
    users,
};

export default rootReducer;
